import { render, staticRenderFns } from "./SingleBayCellDetailModal.vue?vue&type=template&id=1960d9d0&scoped=true"
import script from "./SingleBayCellDetailModal.vue?vue&type=script&lang=ts"
export * from "./SingleBayCellDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./SingleBayCellDetailModal.vue?vue&type=style&index=0&id=1960d9d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960d9d0",
  null
  
)

export default component.exports